import React, { useState } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Detail from '../../../components/Detail/Detail';
import styles from '../assets/styles.scss';
import Result from '../Result/Result';
import RandomNumber from '../RandomNumber/RandomNumber';
import useFinalResult from '../hooks/useFinalResult';
import useRandomNumber from '../hooks/useRandomNumber';
import useResultNumber from '../hooks/useResultNumber';
import useModulusBy from '../hooks/useModulusBy';
import ResultTable from '../ResultTable/ResultTable';

const cx = classNames.bind(styles);

export default function Default({ data }) {
  const {
    game_id: gameId,
    game_code: gameCode,
    seed_hash: seedHash,
    next_game_id: nextGameId,
    next_seed_hash: nextSeedHash,
  } = data;

  const [txIds, setTxIds] = useState(data.prev_txids || data.txids || []);

  function onTxIdChange(index, value) {
    const updatedTxIds = [...txIds];
    updatedTxIds[index] = value;
    setTxIds(updatedTxIds);
  }

  const randomNumber = useRandomNumber(seedHash, txIds);
  const modulusBy = useModulusBy(gameCode);
  const resultNumber = useResultNumber(randomNumber, modulusBy);
  const finalResult = useFinalResult(gameCode, resultNumber);

  return (
    <div>
      <Detail
        contentClassName={cx('small')}
        className={cx('detail')}
        label={`Next Round Seed (${nextGameId || '-'})`}
        content={nextSeedHash}
        copiable={!!nextSeedHash}
      />
      <Detail
        contentClassName={cx('small')}
        className={cx('detail')}
        label={`Current Round Seed (${gameId || '-'})`}
        content={seedHash}
        copiable={!!seedHash}
      />
      <RandomNumber txIds={txIds} seedHash={seedHash} onTxIdChange={onTxIdChange} />
      <Result modulusBy={modulusBy} result={resultNumber} randomNumber={randomNumber} />
      <Detail
        contentClassName={cx('detail-content')}
        className={cx('detail')}
        label="Final Result"
        content={finalResult}
      />
      <ResultTable game={gameCode} />
    </div>
  );
}
Default.propTypes = {
  data: PropTypes.object.isRequired,
};
